/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/14/19
 * Time: 6:50 PM
 */
import React,{Component} from 'react';
import icon from '../../assets/img/soon/commingSoon.gif'
import './CommingSoon.css';

class App extends Component{
  render() {
    return (
      <div className={"div_style"}>
        <h1 className={"h1_style"}>We are currently working on this feature and will launch soon</h1>
        <img className={"img_style"} src={icon} alt={"."} />
      </div>
    );
  }
}


export default App;
